export const SET_SUCCESS_SUBMIT_MESSAGE = 'SET_SUCCESS_SUBMIT_MESSAGE';
export const SET_GENERAL_ERROR_MESSAGE = 'SET_GENERAL_ERROR_MESSAGE';
export const SET_GENERAL_SUCCESS_MESSAGE = 'SET_GENERAL_SUCCESS_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
